export const GET_ALL_CATEGORIES = 'get_all_categories';
export const GET_ALL_CATEGORIES_SUCCESS = 'get_all_categories_success';
export const ADD_QUESTION ='add_question';
export const DELETE_QUESTION ='delete_question';